<form *ngIf="myForm" [formGroup]="myForm"
      (submit)="(myForm.valid && myForm.dirty && formData && onSubmit())" appDragDropFile (fileDropped)="fileDrop($event)">
    <input (change)="onFileChange($event)" name="file"
           id="fileToUpload" accept=".dll" type="file" style="display:none;">
    <div mat-dialog-title>
        <mat-toolbar class="mat-accent m-0">
            <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
                <span class="title dialog-title">Cadastro de arquivo do Plugin {{pluginName}}</span>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>

    <mat-dialog-content fxLayout="column" fxLayoutAlign="space-between stretch" class="pb-20">

<!--        <mat-form-field>-->
<!--            <input matInput formControlName="version" placeholder="Versão (x.x.x.x)">-->
<!--            <mat-error>-->
<!--                {{myForm.get('version').errors | error}}-->
<!--            </mat-error>-->
<!--        </mat-form-field>-->
        <mat-form-field>
            <mat-select placeholder="Expr. para versão mínima do Client" formControlName="minClientVersionExpression">
                <mat-option *ngFor="let expression of minExpressions" [value]="expression">
                    {{expression}}
                </mat-option>
            </mat-select>
            <mat-error>
                {{myForm.get('minClientVersionExpression').errors | error}}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input matInput formControlName="minClientVersion" placeholder="Versão mínima do Client (x.x.x.x)"
                   [attr.disabled]="myForm.get('minClientVersionExpression').value == 'ANY'">
            <mat-error>
                {{myForm.get('minClientVersion').errors | error}}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="Expr. para versão máxima do Client" formControlName="maxClientVersionExpression">
                <mat-option *ngFor="let expression of maxExpressions" [value]="expression">
                    {{expression}}
                </mat-option>
            </mat-select>
            <mat-error>
                {{myForm.get('maxClientVersionExpression').errors | error}}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input matInput formControlName="maxClientVersion" placeholder="Versão máxima do Client (x.x.x.x)"
                   [attr.disabled]="myForm.get('maxClientVersionExpression').value == 'ANY'">
            <mat-error>
                {{myForm.get('maxClientVersion').errors | error}}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Dependencias</mat-label>
            <mat-select placeholder="Dependencias" formControlName="dependencyIds" multiple>
                <mat-option *ngFor="let serverPluginDependencyFile of serverPluginService.serverPluginDependencyFile$ | async" [value]="serverPluginDependencyFile.id">
                    {{serverPluginDependencyFile.name}}-{{serverPluginDependencyFile.version}}
                </mat-option>
            </mat-select>
            <mat-error>
                {{myForm.get('dependencyIds').errors | error}}
            </mat-error>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                {{getFileName()}}
            </div>
            <button type="button" mat-raised-button color="accent" onclick="document.getElementById('fileToUpload').click()">
                <mat-icon class="mr-5">cloud_upload</mat-icon>
                Enviar arquivo
            </button>
        </div>
    </mat-dialog-content>


    <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between end" fxFill class="p-16 grey-50-bg border-top">
        <button type="submit" mat-raised-button color="accent"
                [disabled]="(!myForm.valid || myForm.pristine || !formData)"
                aria-label="Salvar">
            <span *ngIf="myForm.get('id')?.value; else newUser">Salvar</span>
            <ng-template #newUser>Criar</ng-template>
        </button>
        <button type="button" mat-raised-button color="primary" (click)="onCancel()">Cancelar</button>

    </mat-dialog-actions>
</form>